/**
 * Device ID utility
 * - Generates a stable, anonymous device identifier stored in localStorage
 * - Uses crypto APIs when available for high-quality randomness
 */

const STORAGE_KEY = 'visitor-device-id-v1';

const generateUUID = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // RFC4122 v4 compliant fallback
  const getRandomValues = (n) => {
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
      const arr = new Uint8Array(n);
      crypto.getRandomValues(arr);
      return Array.from(arr);
    }
    // Ultra-fallback using Math.random (less ideal but sufficient)
    return Array.from({ length: n }, () => Math.floor(Math.random() * 256));
  };

  const bytes = getRandomValues(16);
  // Per RFC 4122 section 4.4
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10

  const hex = bytes.map(b => b.toString(16).padStart(2, '0'));
  return (
    hex.slice(0, 4).join('') + '-' +
    hex.slice(4, 6).join('') + '-' +
    hex.slice(6, 8).join('') + '-' +
    hex.slice(8, 10).join('') + '-' +
    hex.slice(10, 16).join('')
  );
};

export const getDeviceId = () => {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const id = generateUUID();
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch (e) {
    // Fallback to session-only ID if localStorage fails
    if (!window.__sessionDeviceId) {
      window.__sessionDeviceId = generateUUID();
    }
    return window.__sessionDeviceId;
  }
};

export default getDeviceId;
